import { get } from './api';

// 获取月度报告，渠道码就是id，结算金额前端减下
const getSubcnMonthReport = get('cn/subcn-month-report');

// 月度订单报表，支持手机号查询，不支持用户名查询
const getOrderMonthReport = get('cn/orders-month-report');

// 月度注册用户报表，支持手机号查询，不支持用户名查询
const getUsersMonthReport = get('cn/users-month-report');

export {
  getSubcnMonthReport,
  getOrderMonthReport,
  getUsersMonthReport
}
